import React, { createContext, useContext } from 'react';
import type { CategoryContext } from '../types';

/**
 * StandardPickerModal에서 사용하는 카테고리 관련 컨텍스트
 * Props drilling을 제거하기 위해 모달 레벨에서 제공됩니다.
 */

const StandardPickerCategoryContext = createContext<CategoryContext | undefined>(undefined);

/**
 * StandardPickerModal의 카테고리 정보를 제공하는 Context Provider
 *
 * @example
 * <StandardPickerCategoryProvider value={{ categoryContext, subjectTree }}>
 *   <StandardPickerModal />
 * </StandardPickerCategoryProvider>
 */
export const StandardPickerCategoryProvider = ({
  children,
  value
}: {
  children: React.ReactNode;
  value: CategoryContext;
}) => {
  return <StandardPickerCategoryContext.Provider value={value} data-sentry-element="unknown" data-sentry-component="StandardPickerCategoryProvider" data-sentry-source-file="StandardPickerCategoryProvider.tsx">
      {children}
    </StandardPickerCategoryContext.Provider>;
};

/**
 * StandardPickerModal의 카테고리 정보를 사용하는 훅
 *
 * @throws {Error} StandardPickerCategoryProvider 외부에서 사용된 경우
 *
 * @example
 * const { categoryContext, subjectTree } = useStandardPickerCategory();
 */
export const useStandardPickerCategory = (): CategoryContext => {
  const context = useContext(StandardPickerCategoryContext);
  if (context === undefined) {
    throw new Error('useStandardPickerCategory must be used within StandardPickerCategoryProvider');
  }
  return context;
};